/**
 * File animations.js
 * GSAP https://gsap.com/docs/v3/
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll('.animated-counter').forEach((number) => {
    const end = number.getAttribute('data-end');
    const duration = number.getAttribute('data-duration');

    if (end && number) {
        gsap.to(number, {
            scrollTrigger: {
                trigger: number,
            },
            innerText: end,
            duration: duration,
            ease: 'power1.inOut',
            snap: { innerText: 1 },
            onUpdate: function() {
                number.innerText = Math.ceil(number.innerText);
            }
        });
    }
});

document.querySelectorAll('.animated-bounce-card').forEach((card, i) => {
    gsap.from(card, {
        y: 80,
        opacity: 0,
        duration: 1,
        ease: "bounce.out",
        delay: i * 0.15,
        scrollTrigger: {
            trigger: card,
            start: "top 85%",
            once: true
        }
    });
});

document.querySelectorAll('.animated-slide-in-2x-cards').forEach((card, i) => {
    gsap.matchMedia().add("(max-width: 992px)", () => {
        gsap.from(card, {
            scrollTrigger: {
                trigger: card,
                start: 'top bottom',
            },
            x: i % 2 === 0 ? '100vw' : '-100vw',
            duration: 1,
        });
    }).add("(min-width: 992px)", () => {
        gsap.from(card, {
            scrollTrigger: {
                trigger: card,
                toggleActions: 'play reset play reset',
            },
            x: i % 2 === 0 ? '50vw' : '-50vw',
            duration: 1,
        });
    });
});

document.querySelectorAll('.animated-slide-in-3x-cards').forEach((card, i) => {
    gsap.matchMedia().add("(max-width: 992px)", () => {
        gsap.from(card, {
            scrollTrigger: {
                trigger: card,
                start: 'top bottom',
            },
            x: i % 2 === 0 ? '100vw' : '-100vw',
            duration: 1,
        });
    }).add("(min-width: 992px)", () => {
        if (i % 3 === 0) {
            gsap.from(card, {
                scrollTrigger: {
                    trigger: card,
                    start: 'top bottom',
                },
                x: '100vw',
                duration: 1,
            });
        } else if (i % 3 === 1) {
            gsap.from(card, {
                scrollTrigger: {
                    trigger: card,
                    start: 'top bottom',
                },
                y: '-100vw',
                duration: 1,
            });
        } else if (i % 3 === 2) {
            gsap.from(card, {
                scrollTrigger: {
                    trigger: card,
                    start: 'top bottom',
                },
                x: '-100vw',
                duration: 1,
            });
        }
    });
});